import { MutableRefObject } from 'react';
import { OverlayPositionType } from '../../ThemeProvider/types';

export interface SelectOverlayProps {
  target: string;
  isOpen: boolean;
  options: any[];
  keyProperty?: string;
  showProperty?: string;
  inputValue?: InputValueType | null | any;
  labelAll: string;
  chevronRef: MutableRefObject<HTMLDivElement>;
  inputRef: MutableRefObject<HTMLDivElement>;
  targetHeight?: number;
  overlayPosition?: OverlayPositionType;
  emptyStateLabel?: string;
  overAll?: boolean;
  testId?: string;
  onSelection: (data: any) => (e?: any) => void;
  onSelectAll: (data: any) => void;
  setIsOpen: (isOpen: boolean) => void;
}

export const OVERLAY_MAX_HEIGHT = 144;

export enum ClickType {
  FirstClick = 0,
  SecondClick,
  OtherClick,
}

export type InputPositionType = {
  width: number;
  top: number;
  bottom: number;
  x: number;
};

type InputValueType = { from: string; until: string } | string;
